import { InputNumber } from "antd"

export const LimitInput = ({
  value,
  setValue,
  disabled = false,
} : {
  value: number | null,
  setValue: (value : number | null) => void,
  disabled?: boolean
}) => {
  return <InputNumber
    addonBefore="$"
    style={{ display: 'block', width: '100%' }}
    placeholder="Limit Price"
    value={value}
    onChange={(value) => setValue(value)}
    min={0}
  />
}